import { AnimatedSection } from "@/components/shared/AnimatedSection";
import { BgOrbs } from "@/components/shared/BgOrbs";

/**
 * Centered contact CTA section.
 */
export function Contact() {
  return (
    <section id="contact" className="py-32 px-6 bg-[#F7F8FA] relative overflow-hidden">
      <BgOrbs variant="default" />
      <AnimatedSection>
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-xs font-medium uppercase tracking-[0.07em] font-[DM_Sans] text-[#888888] mb-4">
            Let's work together
          </p>
          <h2 className="font-[Bricolage_Grotesque] font-extrabold tracking-[-0.04em] text-[clamp(2rem,5vw,3.5rem)] text-[#1A1A1A] mb-6 leading-tight">
            Let's cook something{" "}
            <span className="text-[#1D3FE8]">together.</span>
          </h2>
          <p className="text-[#888888] font-[DM_Sans] leading-relaxed mb-12 text-lg">
            I'm looking for a team with a strong design culture, open
            communication, and investment to grow our careers. Bonus if we
            share playlists and memes along the way.
          </p>

          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="mailto:veronica.agbernal@gmail.com"
                className="px-8 py-4 rounded-full bg-[#1D3FE8] text-white font-medium font-[DM_Sans] hover:bg-[#1532c0] transition-colors text-lg"
              >
                Say hello →
              </a>
              <a
                href="https://www.linkedin.com/in/veronicaab/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 rounded-full border border-[#E2E8F0] text-[#1A1A1A] font-medium font-[DM_Sans] hover:border-[#1D3FE8] hover:text-[#1D3FE8] transition-colors text-lg bg-white/50"
              >
                LinkedIn ↗
              </a>
            </div>
            <div className="flex gap-6">
              <a
                href="https://www.instagram.com/veronica.aguilar__/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#888888] font-[DM_Sans] text-sm hover:text-[#1D3FE8] transition-colors"
              >
                Instagram ↗
              </a>
              <a
                href="https://dribbble.com/VeronicaAguilar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#888888] font-[DM_Sans] text-sm hover:text-[#1D3FE8] transition-colors"
              >
                Dribbble ↗
              </a>
            </div>
          </div>
        </div>
      </AnimatedSection>
    </section>
  );
}
